import { createContext, useContext } from 'react';

/**
 * How far below the top of the layout MainLayout hosts the header. The design frames put the top
 * bar 50 down, under a phone's status bar; on mobile web there is no status bar, so Home hosts its
 * header 34 (of the 844 frame) down to keep the bar where the design has it, and every other
 * screen does the same so the bar never moves between screens. Native layouts sit under the real
 * status bar instead and leave this 0.
 *
 * A screen that lays its content out under the header itself (`fullBleed`) adds this to the
 * clearance it leaves for the header; screens in flow under the header are pushed down by it.
 */
export const HeaderTopOffsetContext = createContext(0);

export const useHeaderTopOffset = () => useContext(HeaderTopOffsetContext);
